import DataLayer from '@/helpers/dataLayer.js';

export default function actions() {
	return {
		contract: async ({ getters, commit }) => {
			const response = await window.axios.post(`/api/contracting/contract`, {
				checkboxes: getters.getCheckboxes,
				contract_id: getters.getBrokerageData.contract_id,
				damageEvent: getters.getDamageEvent,
				damageCount: getters.getDataByProp('damageCount'),
				damageAmount: getters.getDataByProp('damageAmount'),
			});

			if (response.data.success) {
				DataLayer.setEvent('Sikeres_kotes', { Value: response.data.results.annual_fee });
				commit('setOfferResponse', response.data.results);
				return 'contracting-success';
			}

			commit('setWsErrors', response.data.errors);
			return 'contracting-error';
		},
        consultantContract: async ({ getters, commit }) => {
            const response = await window.axios.post(`/api/contracting/consultant_contract`, {
                contract_id: getters.getBrokerageData.contract_id,
            });

            if (response.data.success) {
                DataLayer.setEvent('Sikeres_feltoltes', { Value: response.data.results.annual_fee });
                commit('setOfferResponse', response.data.results);
                return 'contracting-success';
            }

            commit('setWsErrors', response.data.errors);
            return 'contracting-error';
        },
        prepare_contract: async ({ getters, commit }) => {
            const response = await window.axios.post(`/api/contracting/prepare_contract`, {
                checkboxes: getters.getCheckboxes,
                contract_id: getters.getBrokerageData.contract_id,
                damageEvent: getters.getDamageEvent,
                damageCount: getters.getDataByProp('damageCount'),
                damageAmount: getters.getDataByProp('damageAmount'),
            });
            return !response.data.error;
        },
		save: async ({ commit, getters, rootGetters }, summaryView) => {
			const toPdf = {
				user_name: `${getters.getAllFormData.baseData.contractDetails.last_name} ${getters.getAllFormData.baseData.contractDetails.first_name}`,
				user_email: getters.getAllFormData.baseData.contractDetails.email,
				user_phone: getters.getAllFormData.baseData.contractDetails.phone_number,
				address: getters.getAllFormData.baseData.permanentAddress,
				insurer_full_name: getters.getSelectedOffer.insurer_full_name,
				product_name: getters.getSelectedOffer.product_name,
				start_of_risk: rootGetters.getCalculation.start_of_risk,
				annual_fee: getters.getSelectedOffer.annual_fee,
				insurance_value: getters.getSelectedOffer.sum_fee,
				summaryView,
			};

			const response = await window.axios.post('/api/contracting/save', {
				toPdf,
				offer: getters.getSelectedOffer,
				baseData: getters.getAllFormData.baseData,
				financingData: getters.getAllFormData.financingData,
				insuredData: getters.getAllFormData.insuredData,
				calculation: rootGetters.getCalculation,
			});

			if (response.data.success) {
				commit('setBrokerageData', {
					contract_id: response.data.contract_id,
					pdf: response.data.pdf,
				});
			}

			return response.data.success;
		},
		saveNew: async ({ commit, getters, rootGetters }, { dataKey, summaryView, isLast, noPdf }) => {
			let data = {
				isLast: isLast !== undefined ? isLast : false,
			};

			if (summaryView !== undefined) {
				const toPdf = {
					user_name: `${getters.getAllFormData.baseData.contractDetails.last_name} ${getters.getAllFormData.baseData.contractDetails.first_name}`,
					user_email: getters.getAllFormData.baseData.contractDetails.email,
					user_phone:
						getters.getAllFormData.baseData.contractDetails?.mobile_number ??
						getters.getAllFormData.baseData.contractDetails?.phone_number,
					address: getters.getAllFormData.baseData.permanentAddress,
					insurer_full_name: getters.getSelectedOffer.insurer_full_name,
					product_name: getters.getSelectedOffer.product_name,
					start_of_risk: rootGetters.getCalculation.start_of_risk,
					annual_fee: getters.getSelectedOffer.annual_fee,
					insurance_value: getters.getSelectedOffer.sum_fee,
					summaryView,
				};

				data = { ...data, toPdf };
			}

			if (getters.getCurrentContract !== null) {
				data = { ...data, contract_id: getters.getCurrentContract };

				if (dataKey !== undefined) {
					data = { ...data, [dataKey]: getters.getAllFormData[dataKey] };
				}
			} else {
				data = {
					...data,
					offer: getters.getSelectedOffer,
					baseData: getters.getAllFormData.baseData,
					calculation: rootGetters.getCalculation,
				};
			}

            if(noPdf !== undefined) {
                data = {
                    ...data,
                    noPdf,
                };
            }

			const response = await window.axios.post(`/api/contracting/save`, data);

			if (response.data.success) {
				if (response.data.pdf !== null) {
					commit('setBrokerageData', {
						contract_id: response.data.contract_id,
						pdf: response.data.pdf,
                        type: null,
					});
				}

				commit('setCurrentContract', response.data.contract_id);
			}

			return response.data.success;
		},
		saveUser: async ({ rootGetters }, payload) => {
			const response = await window.axios.post(
				`/api/contracting/user/${rootGetters.getCalculation.user_id}/save`,
				payload,
			);
		},
		fetchFinancers: async ({ commit }) => {
			const response = await window.axios.get('/api/contracting/financers');

			if (response.data.success) {
				commit('setFinancers', response.data.financers);
			}
		},
		fetchBanks: async ({ commit }) => {
			const response = await window.axios.get('/api/contracting/banks');

			if (response.data.success) {
				commit('setBanks', response.data.banks);
			}
		},
        fetchContract: async ({ commit },{hash}) => {
            const response = await window.axios.get(`/vue/contract/${hash}`);

            if (response.data.success) {
                commit('setBrokerageData', {
                    contract_id: response.data.contract_id,
                    pdf: response.data.pdf,
                    type: response.data?.contract_type,
                });
                commit('setContractSummary',response.data.summary);
            }
        },
        sendEmailToClient: async ({ commit },{hash}) => {
            const response = await window.axios.post(`/api/contracting/send-contract-to-client/${hash}`);
            return !!response.data?.success;
        },
        setContractType: async ({ commit, getters },{ contract_id, type, offers }) => {
            const response = await window.axios.post(`/api/contracting/set-contract-type`,{
                contract_id,
                type,
                offers,
            });

            if(response.data?.success) {
                commit('setBrokerageData', {
                    ...getters.getBrokerageData,
                    pdf: response.data.pdf,
                    type: type,
                });
            }
            return !!response.data?.success;
        },
        uploadSignedContract: async ({getters},{contract, termination, terminationPermission}) => {
            const formData = new FormData();
            if(contract !== null) {
                for (let i = 0; i < contract.length; i++) {
                    formData.append('contract[' + i + ']', contract[i]);
                }
            }
            if(termination !== null) {
                for (let i = 0; i < termination.length; i++ ) {
                    formData.append('termination[' + i + ']', termination[i]);
                }
            }

            if(terminationPermission !== null) {
                for (let i = 0; i < terminationPermission.length; i++ ) {
                    formData.append('terminationPermission[' + i + ']', terminationPermission[i]);
                }
            }

            const headers = { 'Content-Type': 'multipart/form-data' };
            let ret;
            try {
                const response = await axios.post(`/api/contracting/upload-signed-contract/${getters.getBrokerageData.contract_id}`, formData, { headers });
                ret = {
                    error: response.data?.message,
                    success: !!response.data?.success,
                };
            } catch(error) {
                if(error.response && error.response.status === 422) {
                    ret = {
                        success: false,
                        errors: error.response.data?.errors,
                    };
                }
            }
            return ret;
        },
	};
}
